// extracted by mini-css-extract-plugin
export default {"services-industry-item":"ServicesIndustriesItem_services-industry-item__0w821"};